define("ember-basic-dropdown/components/basic-dropdown-trigger", ["exports", "@ember/component", "@ember/template-factory", "@glimmer/component", "@ember/object"], function (_exports, _component, _templateFactory, _component2, _object) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;

  var _class;

  0; //eaimeta@70e063a35619d71f0,"ember-cli-htmlbars",0,"@glimmer/component",0,"@ember/object"eaimeta@70e063a35619d71f

  function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }

  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    {{#let (element (or @htmlTag 'div')) as |OptionalTag|}}
    {{!-- template-lint-disable no-pointer-down-event-binding --}}
    <OptionalTag
      class='ember-basic-dropdown-trigger
        {{if @renderInPlace " ember-basic-dropdown-trigger--in-place"}}
        {{if @hPosition (concat " ember-basic-dropdown-trigger--" @hPosition)}}
        {{if @vPosition (concat " ember-basic-dropdown-trigger--" @vPosition)}}
        {{@defaultClass}}'
      {{basic-dropdown-trigger
        dropdown=@dropdown
        eventType=@eventType
        stopPropagation=@stopPropagation
      }}
      tabindex={{unless @dropdown.disabled '0'}}
      ...attributes
      {{on 'mousedown' (fn this.disableDocumentTextSelect true)}}
      {{on 'mouseup' (fn this.disableDocumentTextSelect false)}}
      {{! V1 compatibility - See #498 }}
      {{on 'keydown' (fn (or @onKeyDown this.noop) @dropdown)}}
      {{on 'mousedown' (fn (or @onMouseDown this.noop) @dropdown)}}
      {{on 'touchend' (fn (or @onTouchEnd this.noop) @dropdown)}}
      {{on 'click' (fn (or @onClick this.noop) @dropdown)}}
      {{on 'mouseenter' (fn (or @onMouseEnter this.noop) @dropdown)}}
      {{on 'mouseleave' (fn (or @onMouseLeave this.noop) @dropdown)}}
      {{on 'focus' (fn (or @onFocus this.noop) @dropdown)}}
      {{on 'blur' (fn (or @onBlur this.noop) @dropdown)}}
      {{on 'focusin' (fn (or @onFocusIn this.noop) @dropdown)}}
      {{on 'focusout' (fn (or @onFocusOut this.noop) @dropdown)}}
    >
      {{yield}}
    </OptionalTag>
  {{/let}}
  */
  {
    "id": "XrQmCgt8",
    "block": "[[[44,[[28,[37,1],[[28,[37,2],[[30,1],\"div\"],null]],null]],[[[1,\"  \"],[8,[30,2],[[16,0,[29,[\"ember-basic-dropdown-trigger\\n      \",[52,[30,3],\" ember-basic-dropdown-trigger--in-place\"],\"\\n      \",[52,[30,4],[28,[37,4],[\" ember-basic-dropdown-trigger--\",[30,4]],null]],\"\\n      \",[52,[30,5],[28,[37,4],[\" ember-basic-dropdown-trigger--\",[30,5]],null]],\"\\n      \",[30,6]]]],[16,\"tabindex\",[52,[51,[30,7,[\"disabled\"]]],\"0\"]],[17,8],[4,[38,6],null,[[\"dropdown\",\"eventType\",\"stopPropagation\"],[[30,7],[30,9],[30,10]]]],[4,[38,7],[\"mousedown\",[28,[37,8],[[30,0,[\"disableDocumentTextSelect\"]],true],null]],null],[4,[38,7],[\"mouseup\",[28,[37,8],[[30,0,[\"disableDocumentTextSelect\"]],false],null]],null],[4,[38,7],[\"keydown\",[28,[37,8],[[28,[37,2],[[30,11],[30,0,[\"noop\"]]],null],[30,7]],null]],null],[4,[38,7],[\"mousedown\",[28,[37,8],[[28,[37,2],[[30,12],[30,0,[\"noop\"]]],null],[30,7]],null]],null],[4,[38,7],[\"touchend\",[28,[37,8],[[28,[37,2],[[30,13],[30,0,[\"noop\"]]],null],[30,7]],null]],null],[4,[38,7],[\"click\",[28,[37,8],[[28,[37,2],[[30,14],[30,0,[\"noop\"]]],null],[30,7]],null]],null],[4,[38,7],[\"mouseenter\",[28,[37,8],[[28,[37,2],[[30,15],[30,0,[\"noop\"]]],null],[30,7]],null]],null],[4,[38,7],[\"mouseleave\",[28,[37,8],[[28,[37,2],[[30,16],[30,0,[\"noop\"]]],null],[30,7]],null]],null],[4,[38,7],[\"focus\",[28,[37,8],[[28,[37,2],[[30,17],[30,0,[\"noop\"]]],null],[30,7]],null]],null],[4,[38,7],[\"blur\",[28,[37,8],[[28,[37,2],[[30,18],[30,0,[\"noop\"]]],null],[30,7]],null]],null],[4,[38,7],[\"focusin\",[28,[37,8],[[28,[37,2],[[30,19],[30,0,[\"noop\"]]],null],[30,7]],null]],null],[4,[38,7],[\"focusout\",[28,[37,8],[[28,[37,2],[[30,20],[30,0,[\"noop\"]]],null],[30,7]],null]],null]],null,[[\"default\"],[[[[1,\"\\n    \"],[18,21,null],[1,\"\\n  \"]],[]]]]],[1,\"\\n\"]],[2]]]],[\"@htmlTag\",\"OptionalTag\",\"@renderInPlace\",\"@hPosition\",\"@vPosition\",\"@defaultClass\",\"@dropdown\",\"&attrs\",\"@eventType\",\"@stopPropagation\",\"@onKeyDown\",\"@onMouseDown\",\"@onTouchEnd\",\"@onClick\",\"@onMouseEnter\",\"@onMouseLeave\",\"@onFocus\",\"@onBlur\",\"@onFocusIn\",\"@onFocusOut\",\"&default\"],false,[\"let\",\"element\",\"or\",\"if\",\"concat\",\"unless\",\"basic-dropdown-trigger\",\"on\",\"fn\",\"yield\"]]",
    "moduleName": "ember-basic-dropdown/components/basic-dropdown-trigger.hbs",
    "isStrictMode": false
  });

  let BasicDropdownTrigger = (_class = class BasicDropdownTrigger extends _component2.default {
    // Actions

    /**
     * Allows similair behaviour to `ember-composable-helpers`' `optional` helper.
     * Avoids adding extra dependencies.
     * Can be removed when the template `V1` compatability event handlers are removed.
     *
     * @see https://github.com/cibernox/ember-basic-dropdown/issues/498
     * @memberof BasicDropdownContent
     */
    noop() {}

    disableDocumentTextSelect(disable) {
      if (disable) {
        document.body.classList.add('ember-basic-dropdown-text-select-disabled');
      } else {
        document.body.classList.remove('ember-basic-dropdown-text-select-disabled');
      }
    }

  }, (_applyDecoratedDescriptor(_class.prototype, "disableDocumentTextSelect", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "disableDocumentTextSelect"), _class.prototype)), _class);
  _exports.default = BasicDropdownTrigger;
  (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, BasicDropdownTrigger);
});